const indexItems = [
  { label: '动作片', icon: 'ri-sword-fill', count: '8,200+', color: 'bg-primary-100 text-primary-600' },
  { label: '喜剧片', icon: 'ri-emotion-laugh-fill', count: '6,500+', color: 'bg-accent-100 text-accent-700' },
  { label: '悬疑片', icon: 'ri-magic-fill', count: '4,300+', color: 'bg-secondary-100 text-secondary-700' },
  { label: '科幻片', icon: 'ri-rocket-fill', count: '5,100+', color: 'bg-primary-100 text-primary-600' },
  { label: '爱情片', icon: 'ri-heart-pulse-fill', count: '7,800+', color: 'bg-accent-100 text-accent-700' },
  { label: '恐怖片', icon: 'ri-ghost-fill', count: '3,200+', color: 'bg-secondary-100 text-secondary-700' },
  { label: '动画片', icon: 'ri-emotion-happy-fill', count: '9,400+', color: 'bg-primary-100 text-primary-600' },
  { label: '纪录片', icon: 'ri-earth-fill', count: '4,900+', color: 'bg-accent-100 text-accent-700' },
];

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            分类索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            按类型快速浏览电影大全，精准定位你想看的每一部
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-300/40 hover:bg-background-50 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.color}`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <span className="font-heading font-semibold text-foreground-900 text-sm group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count} 部</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}